import styled, { keyframes } from 'styled-components';

const fadeInFromBottom = keyframes`
  from {
    opacity: 0;
    margin-top: 1rem;
  }
  to {
    opacity: 1;
    margin-top: 0;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledContentContainer = styled.div`
  animation: ${fadeIn} 1000ms forwards cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: row;
  min-height: calc(100% - 63px);
`;

export const SidebarContainer = styled.div`
  animation: ${fadeInFromBottom} 2000ms forwards cubic-bezier(0.4, 0, 0.2, 1);
  width: 20%;
  flex-grow: 1;
  flex-shrink: 0;
  border-right: 1px solid #eaeaea;
  padding: ${({ theme }) =>
    `${theme.baseline} 0 ${theme.baseline} ${theme.baseline}`};
`;
